import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

import { MotVacationsCriteria, VacationsSeason } from '@app/activo2/manage-vacations/manage-vacations.model';
import { MSafeAny } from '@app/shared/models/safe-any/safe-any.model';

@Component({
  selector: 'app-mot-criteria-modal',
  templateUrl: './criteria-modal.component.html',
  styleUrls: ['./criteria-modal.component.scss']
})
export class CriteriaModalComponent implements OnInit {
  criteria!: MotVacationsCriteria;
  selectedSeason!: VacationsSeason;

  constructor(@Inject(MAT_DIALOG_DATA) public data: MSafeAny) {}

  ngOnInit() {
    this.criteria = this.data.criteria;
    this.selectedSeason = this.data.selectedSeason;
  }
}
